import { render, staticRenderFns } from "./order_details.vue?vue&type=template&id=5eb8f22e&scoped=true"
import script from "./order_details.vue?vue&type=script&lang=js"
export * from "./order_details.vue?vue&type=script&lang=js"
import style0 from "./order_details.vue?vue&type=style&index=0&id=5eb8f22e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb8f22e",
  null
  
)

export default component.exports